import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import OnlineIcon from "../../../assets/imgs/online.gif";
import OfflineIcon from "../../../assets/imgs/offline.gif";
import PanelFrame from "../../ui/PanelFrame";
import { useLang } from "../../../i18n/LangContext";
import "./owners.scss";

const RANK_COLORS = {
  Owner: "red",
  CEO: "darkred",
  Manager: "#eb17d9",
  Developer: "gold",
  GameMaster: "blue",
  Support: "#0f8f51",
  Moderator: "yellow",
};

const OwnersSideBarRight = () => {
  const owners = useSelector((state) => state.reducerWeb.owners.data) || [];
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <PanelFrame title={t("game_staff")}>
      <div className="containerOwners">
        <table className="Owners mu-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Rank</th>
            </tr>
          </thead>
          <tbody>
            {owners.length > 0
              ? owners.map((staff) => {
                  const rankColor = RANK_COLORS[staff.rank];
                  return (
                    <tr
                      className="newCursor"
                      key={`${staff.rank}-${staff.Name}`}
                      onClick={() => navigate(`/player/${staff.Name}`)}
                    >
                      <td className="ContainerOwnersUserOnline">
                        <span className="ownersUserOnline">
                          {staff.ConnectStat == 1 ? (
                            <span>
                              <img src={OnlineIcon} alt="" />
                            </span>
                          ) : (
                            <span>
                              <img src={OfflineIcon} alt="" />
                            </span>
                          )}
                        </span>
                        {staff.Name}
                      </td>
                      <td>
                        <b style={rankColor ? { color: rankColor } : undefined}>
                          {staff.rank}
                        </b>
                      </td>
                    </tr>
                  );
                })
              : [0, 1, 2, 3].map((i) => (
                  <tr key={`staff-empty-${i}`} className="mu-row-placeholder">
                    <td>—</td>
                    <td>—</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </PanelFrame>
  );
};

export default OwnersSideBarRight;
